<div class="footer">
    <div class="content">
        <div class="institutional column">
            <strong>{{ 'footer.institutional' | translate }}</strong>
            <span *ngIf="checkConfiguration('aboutUs')" (click)="goToUrl('aboutUs')">{{ 'footer.about' | translate
                }}</span>
            <span *ngIf="checkConfiguration('policies/privacy')" (click)="goToUrl('policies/privacy')">{{
                'footer.policy' | translate }}</span>
            <span *ngIf="checkConfiguration('workWithUs')" (click)="goToUrl('workWithUs')">{{ 'footer.work' | translate
                }}</span>
            <span (click)="openContactChannel()" *ngIf="enableContactButton">{{ 'footer.contact' | translate }}</span>
        </div>
        <div class="user-help column">
            <strong>{{ 'footer.help' | translate }}</strong>
            <span *ngIf="checkConfiguration('policies/exchangesAndReturns')"
                (click)="goToUrl('policies/exchangesAndReturns')">{{ 'footer.exchanges' | translate }}</span>
            <span *ngIf="checkConfiguration('account')" (click)="goToUrl('account')">{{ 'footer.account' | translate
                }}</span>
            <span *ngIf="checkConfiguration('policies/delivery')" (click)="goToUrl('policies/delivery')">{{
                'footer.deliveries' | translate }}</span>
            <span *ngIf="checkConfiguration('policies/cancellation')" (click)="goToUrl('policies/cancellation')">{{
                'footer.cancellation' | translate }}</span>
        </div>
        <div class="social-networks">
            <div class="networks">
                <img *ngFor="let socialMedia of socialMedias" (click)="goToUrl('socialMidias/' + socialMedia)"
                    [src]="'/assets/images/' + socialMedia + '.svg'" [alt]="socialMedia"
                    [matTooltip]="(('footer.' + socialMedia) | translate)" matTooltipClass="tooltip-primary">
            </div>
        </div>
    </div>
    <div class="all-rights centered" id="firstRightsLine">
        <p>
            {{line1}}
        </p>
    </div>
    <div class="all-rights centered" id="firstRightsLine">
        <p>
            {{line2}}
        </p>
    </div>
    <div class="all-rights centered" id="firstRightsLine">
        <p>
            {{line3}}
        </p>
    </div>
    <div class="all-rights centered" id="firstRightsLine">
        <p>
            {{line4}}
        </p>
    </div>
</div>